import { m } from 'framer-motion';

interface MeshpitLogoProps {
  className?: string;
}

export function MeshpitLogo({ className }: MeshpitLogoProps) {
  return (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx="24" cy="24" r="20" stroke="currentColor" strokeWidth="4" />
      <m.circle
        cx="24"
        cy="23"
        r="13"
        stroke="currentColor"
        strokeWidth="2"
        initial={{ r: 13, cy: 23, opacity: 1, strokeWidth: 2 }}
        animate={{
          r: [13, 13, 20, 0, 13],
          cy: [23, 23, 24, 23, 23],
          opacity: [1, 1, 0, 0, 1],
          strokeWidth: [2, 2, 4, 0, 2],
        }}
        transition={{
          duration: 10,
          times: [0, 0.9, 0.95, 0.96, 1],
          ease: 'easeInOut',
          repeat: Infinity,
        }}
      />
      <m.circle
        cx="23"
        cy="21"
        r="6.5"
        stroke="currentColor"
        strokeWidth="1"
        initial={{ r: 6.5, cx: 23, cy: 21, opacity: 1, strokeWidth: 1 }}
        animate={{
          r: [6.5, 6.5, 20, 0, 6.5],
          cx: [23, 23, 24, 23, 23],
          cy: [21, 21, 24, 21, 21],
          opacity: [1, 1, 0, 0, 1],
          strokeWidth: [1, 1, 4, 0, 1],
        }}
        transition={{
          duration: 10,
          times: [0, 0.9, 0.95, 0.96, 1],
          ease: 'easeInOut',
          repeat: Infinity,
        }}
      />

      <m.circle
        cx="23"
        cy="21"
        r="6.5"
        stroke="currentColor"
        strokeWidth="1"
        initial={{ r: 6.5, opacity: 1 }}
        animate={{
          r: [6.5, 6.5, 0],
          opacity: [1, 1, 0],
        }}
        transition={{
          duration: 10,
          times: [0, 0.9, 1],
          ease: ['linear', 'easeIn'],
          repeat: Infinity,
        }}
      />

      <m.circle
        cx="23"
        cy="21"
        r="6.5"
        stroke="currentColor"
        strokeWidth="1"
        initial={{ r: 6.5, opacity: 1 }}
        animate={{ r: 0, opacity: 0 }}
        transition={{
          duration: 1,
          ease: 'easeIn',
          repeat: Infinity,
          repeatDelay: 9,
        }}
      />
    </svg>
  );
}
